import { observer } from 'mobx-react-lite';

import { Button, XStack } from '@/components/ui';
import { Widget } from '@/features/widgets/widget.parts';

import { FeedSection } from './components/FeedSection';
import { useProactiveAgentFeed } from './use-proactive-agent-feed';
import { WaitingForYouSection } from './WaitingForYouSection';

export const ProactiveAgentFeed = observer(() => {
  const feed = useProactiveAgentFeed();
  if (!feed.enabled) return <WaitingForYouSection />;
  if (feed.isError)
    return (
      <FeedSection>
        <XStack>
          <Button variant="secondary" onClick={feed.retry}>
            Retry loading proactive agents
          </Button>
        </XStack>
      </FeedSection>
    );
  if (feed.isPending)
    return (
      <FeedSection>
        <Widget.Skeleton rows={2} />
      </FeedSection>
    );
  if (!feed.hasAgents) return <WaitingForYouSection />;

  return (
    // A new key per agent resets paging and expanded cards when the selected agent changes
    <WaitingForYouSection
      key={feed.selectedAgent}
      acceptsCard={feed.acceptsCard}
      emptyMessage={
        feed.sourcesPending
          ? 'Routines and reports have not loaded yet, so cards from routines are hidden.'
          : 'No action cards to show yet.'
      }
      footer={
        feed.sourcesPending ? (
          <XStack>
            <Button variant="ghost" onClick={feed.retry}>
              Load routines and reports again
            </Button>
          </XStack>
        ) : null
      }
    />
  );
});
